export default "__VITE_ASSET__BdZwr8sK__"